(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$state'];

    function LoginService ($state) {
        var service = {
            open: open
        };

        return service;

        // Antes abría un modal; ahora lleva a la página de inicio de sesión (/#/user/login)
        function open () {
            $state.go('login');
        }
    }
})();
